import React, { useContext } from "react";
import UserForm from "../form/UserForm";
import { IoCloseCircle } from "react-icons/io5";
import BottomPopup from "./BottomPopup";
import UserContext from "../../context/UserContext";
import PopupHeader from "./PopupHeader";

const ContactPopup = ({ title ,onClose,onGoBack}) => {
  const userCtx = useContext(UserContext);
  return (
    <BottomPopup requirePopup={true}>
      <div className="form-popup">
        <PopupHeader
          title="Your Orders"
          showBackButton={true}
          onGoBack={onGoBack}
          onClose={onClose}
        />
        <UserForm title={title} />
      </div>
    </BottomPopup>
  );
};

export default ContactPopup;